module.exports = __webpack_public_path__ + "img/problem1.e3ffac80.png";